import styled from 'styled-components'
import { darken, media, colors } from 'styles'
import { StyledSwitch } from 'components/Sidebar/MobileMenu'

const StyledSidebar = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  box-sizing: border-box;
  min-height: 100vh;
  width: 20%;
  flex: 0 0 20%;
  border-right: 0.1rem solid ${colors.divider};
  padding-top: 3rem;
  background-color: ${colors.main};
  font-size: 1.8rem;

  .profile-link {
    display: none;
    text-decoration: none;
    color: ${colors.mainInverted};

    .text {
      margin-left: 1rem;
    }

    .username {
      font-weight: 700;
      padding: 0.6rem 0;
    }

    .membership {
      font-size: 1.4rem;
      opacity: 0.8;
      text-transform: uppercase;
    }
  }
  .logout {
    display: none;
    margin: 0 10%;
    text-decoration: none;
    color: ${colors.mainInverted};
    font-size: 2.2rem;
    font-weight: 300;
    padding: 2rem 0;
    opacity: 0.6;
    &:hover {
      opacity: 1;
    }
  }

  .slot2 {
    margin-bottom: 4rem;
    background-color: ${p => darken(0.1, p.theme.colors.main)};
  }

  .logo {
    margin-bottom: 1.5rem;
  }

  .slot-group {
    display: flex;
    flex-direction: column;
    margin-bottom: auto;
  }

  .slot,
  .logo,
  .footer,
  .TranslationSwitch {
    padding: 0 10%;
  }
  .icon {
    align-self: center;
    text-align: center;
    width: 2em;
    height: 1.2em;
  }
  .icon,
  .icon img {
    max-height: 100%;
    max-width: 100%;
  }

  ${media.mobile`
    width: 90vw;
    height: 100vh;
    overflow-y: auto;
    position: fixed;
    top: 0;
    right: ${p => (p.active ? '0' : '-90vw')};
    z-index: 8;
    transition: 0.5s;

    .profile-link {
      display: flex;
      align-items: center;
      flex-shrink: 0;
    }
    .membership {
      margin: 0 0 1rem;
    }
    .logout {
      display: block;
    }
    ${StyledSwitch} {
      flex: none;
    }

    .logo {
      display: none;
    }

    .slot3 {
      display: none;
    }
    .slot-group {
      flex: none;
    }
  `}
`

export default StyledSidebar
